import React, { FC } from 'react';
import { HEIGHT_VALUES } from '../../../../constants';
import * as S from '../../styled';

interface Props {
	heightUnit: string;
	heightValue: string;
	onChangeHeightUnit: (e: any) => void;
	onChangeHeightValue: (e: any) => void;
}

export const HeightInputBlock: FC<Props> = props => {
	const { heightUnit, heightValue, onChangeHeightUnit, onChangeHeightValue } = props;

	return (
		<>
			<S.Title>Your height?</S.Title>
			<S.ValueContainer>
				<S.Input
					id='heightValue'
					type='text'
					name='heightValue'
					value={heightValue}
					placeholder='0'
					onChange={e => onChangeHeightValue(e)}
				/>
				<S.FormRadioGroup>
					<S.FormRadioGroupItem>
						<input
							id={HEIGHT_VALUES.FT}
							type='radio'
							name='height'
							value={HEIGHT_VALUES.FT}
							checked={heightUnit === HEIGHT_VALUES.FT}
							onChange={e => onChangeHeightUnit(e)}
						/>
						<label htmlFor={HEIGHT_VALUES.FT}>Ft</label>
					</S.FormRadioGroupItem>
					<S.FormRadioGroupItem>
						<input
							id={HEIGHT_VALUES.CM}
							type='radio'
							name='height'
							value={HEIGHT_VALUES.CM}
							checked={heightUnit === HEIGHT_VALUES.CM}
							onChange={e => onChangeHeightUnit(e)}
						/>
						<label htmlFor={HEIGHT_VALUES.CM}>Cm</label>
					</S.FormRadioGroupItem>
				</S.FormRadioGroup>
			</S.ValueContainer>
		</>
	);
};
